export default __webpack_public_path__ + "static/media/caroline.a9d9e6ab.jpg";